// extracted by mini-css-extract-plugin
export default {"table":"CampaignPlannerInstanceRowTable_table__AjBId","row":"CampaignPlannerInstanceRowTable_row__LSEi5"};